module.exports = __webpack_public_path__ + "b4079f54e13a69505216f45d306bfce7.MP3";